import { CaseStudy } from '../../types';
import { PRINT_FORGE_HERO } from '../../assets/images';

export const printForge: CaseStudy = {
  id: '6',
  title: '3d Print Forge',
  category: 'Makerspace Management',
  platform: 'SaaS tool',
  imageUrl: PRINT_FORGE_HERO,
  description: 'The command center for your 3D printing workflow. Preview STLs, track filament usage, and manage your printer fleet from a single, high-fidelity interface.',
  screenshots: [],
  comingSoon: true,
  hasPrivacyPolicy: true,
  hasTermsAndConditions: true
};